module.exports = __webpack_public_path__ + "static/jason-11dc4ef61bd55e9261f4c2acb348ae80.png";